import { request } from '../until/axios.js'
// 新增
export function addsysUser(pram) {
  return request({
    url: '/system/sysUser',
    method: 'post',
    data:pram
  })

}
// 修改
export function editsysUser(loginForm) {
  return request({
    url: '/system/sysUser',
    method: 'put',
    data: loginForm
  })

}
// 删除
export function delsysUser(pram) {
  return request({
    url: '/system/sysUser',
    method: 'delete',
    data: pram
  })
}
// 批量删除
export function pidelsysUser(pram) {
  return request({
    url: '/system/sysUser/removes',
    method: 'delete',
    data: pram
  })
}
// 重置密码
export function rectresetPwd(loginForm) {
  return request({
    url: '/system/sysUser/resetPwd',
    method: 'put',
    data: loginForm
  })
}

// 分页查询
export function listPagesysUser(parm) {
  return request({
    url: '/system/sysUser/listPage',
    method: 'get',
    data: parm
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js